module.exports = __webpack_public_path__ + "img/moduli_smartform.438d54e5.png";